<template>
    <div class="side-wrapper">
        <div class="side">
            <div class="side-inner">
                <div class="side-user" @click="link('MyAccount')" :title="$t('side_showUserInfo')">
                    <span class="avatar">
                        <i class="fa fa-user-circle fa-3x" aria-hidden="true"></i>
                    </span>
                    <span class="side-user-avatar-name">
                      <strong>{{ user.email || 'Guest' }}</strong>
                      <span>{{ user.id ? 'Authenticated user' : 'Visitor access' }}</span>
                    </span>
                </div>

                <div v-if="user.id === null">
                    <ul class="nav flex-column">
                        <li class="nav-item">
                            <button class="btn btn-link nav-link btn-block text-left pl-4" @click="link('Register')">
                                <i class="fa fa-user-plus" aria-hidden="true"></i>
                                {{ $t('side_registerAcc') }}
                            </button>
                        </li>
                    </ul>
                    <h3>{{ $t('side_welcomeBack') }}</h3>
                    <login-component dark reset @loggedIn="loggedIn"></login-component>
                </div>
                <div v-else>
                    <ul class="nav flex-column">
                        <li class="nav-item">
                            <button class="btn btn-link nav-link btn-block text-left pl-4" @click="link('PasswordChange')">
                                <i class="fa fa-key" aria-hidden="true"></i>
                                {{ $t('side_changePwd') }}
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="btn btn-link nav-link btn-block text-left pl-4" @click="link('Topup')">
                                <i class="fas fa-hand-holding-usd" aria-hidden="true"></i>
                                {{ $t('side_topUp') }}
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="btn btn-link nav-link btn-block text-left pl-4" @click="link('Logout')">
                                <i class="fa fa-sign-out-alt" aria-hidden="true"></i>
                                {{ $t('side_logout') }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoginComponent from './LoginComponent'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Sidebar',
  components: {LoginComponent},
  computed: {
    ...mapGetters(['language', 'user']),
  },
  methods: {
    ...mapMutations(['toggleSidebar']),
    link (to, toggle = true) {
      if (toggle) {
        this.toggleSidebar()
      }

      this.$router.push({name: to, params: {lang: this.language}})
    },
    loggedIn () {
      this.toggleSidebar()

      // Navigate away from Login screen
      if (this.$route.name === 'Login') {
        this.$router.push({name: 'Home', params: this.$route.params})
      }
    },
  },
}
</script>

<style scoped lang="scss">
    .avatar {
        background: none;
    }

    .side-user {
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        &:hover {
            background-color: rgba(255, 255, 255, 0.08);
        }
    }

    .nav-item {
        transition: all 0.2s ease-in-out;
        &:hover {
            background-color: rgba(255, 255, 255, 0.08);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/utilities/Sidebar.vue